import { AREA_FETCHING, AREA_FAILED, AREA_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case AREA_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case AREA_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case AREA_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
